import DashboardLayout from "@/packages/dashboard/views/DashboardLayout.vue";
import SendToBeneficiary from "@/packages/WaasModules/Merchant/component/SendToBeneficiary.vue";
import MerchantBeneficiaries from "@/packages/WaasModules/Merchant/component/MerchantBeneficiaries.vue";
import QueryAccountBalance from "@/packages/WaasModules/Merchant/component/QueryAccountBalance.vue";

const MerchantRoutes =[
    {
        path: '/dashboard/waas/',
        component: DashboardLayout,
        children: [
            {
                path: 'merchant/beneficiaries',
                component: MerchantBeneficiaries,
                name: "MerchantBeneficiary",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'merchant/send-to-beneficiary',
                component: SendToBeneficiary,
                name: "SendToBeneficiary",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'merchant/query-account-balance',
                component: QueryAccountBalance,
                name: "QueryAccountBalance",
                // meta: { middleware: [Auth]},
            },
        ]
    }
];
export default MerchantRoutes;
